import { Controller } from "@hotwired/stimulus";
import { Root } from "react-dom/client";

import {
  isDynamicImportError,
  reloadForStaleAssets,
} from "@/javascript/lib/stale_assets";

export default class extends Controller {
  reactRoot: Root | null = null;
  // Incremented on each mount attempt and on disconnect, so an in-flight
  // mountInertia() can detect that it has been superseded and bail out.
  private _mountGeneration = 0;

  connect() {
    this.element.addEventListener(
      "turbo:before-morph-element",
      this.eventBeforeMorphElement
    );
    this.element.addEventListener(
      "turbo:morph-element",
      this.eventMorphElement
    );

    this.mountInertia();
  }
  disconnect(): void {
    this._mountGeneration++;

    this.element.removeEventListener(
      "turbo:before-morph-element",
      this.eventBeforeMorphElement
    );
    this.element.removeEventListener(
      "turbo:morph-element",
      this.eventMorphElement
    );

    this.clearAndUnmountInertia();
  }

  private clearAndUnmountInertia() {
    this.reactRoot?.unmount();
    this.reactRoot = null;
    this.element.innerHTML = "";
  }

  private _showSpinner() {
    this.element.innerHTML =
      '<div class="puts-spinner" style="padding:2rem;text-align:center"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></div>';
  }

  private async mountInertia() {
    const generation = ++this._mountGeneration;

    this._showSpinner();

    try {
      const { default: createInertiaApp } = await import(
        "@/javascript/lib/create_inertia_app"
      );

      if (generation !== this._mountGeneration) return;

      const root = await createInertiaApp(this.element.id);
      if (generation !== this._mountGeneration) {
        root.unmount();
        return;
      }
      this.reactRoot = root;
    } catch (error) {
      if (generation !== this._mountGeneration) return;

      if (isDynamicImportError(error) && reloadForStaleAssets()) return;

      console.error("[InertiaController] Failed to mount Inertia app", error);
    }
  }

  private eventBeforeMorphElement = () => {
    this.clearAndUnmountInertia();
  };

  private eventMorphElement = () => {
    this.mountInertia();
  };
}
